const supportedEnvs = ["local", "dev", "preview"];
export const sanitizeEphemeralEnv = (configEnv, queryValue, options) => {
    const { requiredLength = 8, defaultValue = "", preffix } = options !== null && options !== void 0 ? options : {};
    /*
      The query string 'foo=bar&abc=xyz&abc=123' is parsed into:
      {
        "foo": "bar",
        "abc": ["xyz", "123"]
      }
      https://nodejs.org/api/querystring.html#querystringparsestr-sep-eq-options
  
      So queryValue might be a string or an array of strings
      We arbitrarly pick the first value of the query
    */
    const ephemeralId = Array.isArray(queryValue) ? queryValue[0] : queryValue;
    if (!configEnv ||
        !ephemeralId ||
        !supportedEnvs.includes(configEnv) ||
        typeof ephemeralId !== "string" ||
        ephemeralId.length !== requiredLength ||
        !/^[0-9a-z]*$/.test(ephemeralId)) {
        return defaultValue;
    }
    return preffix ? `${preffix}${ephemeralId}` : ephemeralId;
};
